// extracted by mini-css-extract-plugin
module.exports = {"anchor":"anchor_anchor__e6AjG"};